import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import RiskBridgeChart from "../charts/RiskBridgeChart";

/**
 * RiskBridgeBlock - Base forecast -> risk legs -> Risk-adjusted upper bridge (risk_bridge
 * block type, SP3 Component C).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/risk-bridge -> envelope key
 * "risk_bridge" -> { base_label, base_total, legs: [{label, kind, delta}], upper_label,
 * upper_total, band_upper } (T9 internal/boardfigures/riskbridge.go). Rendering (bar layout,
 * sign colouring, band reference line, empty state) is entirely RiskBridgeChart's job (Task
 * 10) - this block only fetches and unwraps the envelope, mirroring VarianceWaterfallBlock's
 * fetch pattern.
 */
const RiskBridgeBlock = ({ title = "Forecast risk bridge", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/risk-bridge`
  );

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-risk-bridge">
      <RiskBridgeChart data={data?.risk_bridge ?? null} />
    </BaseBlock>
  );
};

RiskBridgeBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RiskBridgeBlock;
